<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <vx-card :title="$t('ReportsList') |ToUppercase">

        <vs-button class="float-left" color="success" type="filled" to="/report/add">{{$t('AddReport')}}</vs-button>

        <vs-table :noDataText="$t('NoReportsFound')" max-items="14" pagination search :data="reports" @selected="handleSelected">
          <template slot="thead">
            <vs-th sort-key="id">
              #
            </vs-th>
            <vs-th sort-key="filename">
              {{$t('Filename') |ToUppercase}}
            </vs-th>
            <vs-th sort-key="datetime">
              {{$t('Datetime') |ToUppercase}}
            </vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr :state="tr.disabled == true?'dark':null" :data="tr" :key="data[index].id" v-for="(tr, index) in data">
              <vs-td>{{ data[index].id}}</vs-td>
              <vs-td>{{ data[index].filename}}</vs-td>
              <vs-td>{{ data[index].datetime | moment("D. M. YYYY, hh:mm")}}</vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selected: ""
    };
  },
  filters: {
    ToUppercase: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.toUpperCase();
    },
  },
  computed: {
    reports() {
      return this.$store.state.report.reports.slice();
    }
  },
  created() {
    this.$store.dispatch("report/fetchReports");
  },
  methods: {
    handleSelected(tr) {
      this.$router.push(`/report/${tr.id}`);
    }
  }
};
</script>
